"use client";

import { useEffect, Suspense } from "react";
import { ConsentBootstrap } from "./ConsentBootstrap";
import { ConsentedTags } from "./ConsentedTags";
import { Providers } from "./providers";
import { AppShell } from "@/components/layout/AppShell";
import { CookieConsentBanner } from "@/components/shared/CookieConsent";
import { FeedbackWidget } from "@/components/shared/FeedbackWidget";
import { ROUTES } from "@/constants/routes";
import { mixpanelClient } from "@/lib/mixpanel";
import { Loader2 } from "lucide-react";
import { usePathname } from "next/navigation";

export function RootLayoutClient({ children }: { children: React.ReactNode }) {
  // The region block is a refusal, not a surface to give feedback on — and the widget
  // floats above it, outside AppShell, so hideChrome does not reach it.
  const isRegionBlocked = usePathname() === ROUTES.REGION_BLOCKED;

  useEffect(() => {
    // NOTE: we set the legacy id for mixpanel to save the old id for the user to create the link between the old and new ids
    // It doesn't save the old events in the new user, but gives the information about the user using the app before the migration
    const userId = localStorage.getItem("userId");
    mixpanelClient.setLegacyId(userId);
  }, []);

  return (
    <>
      {/* Outside Providers: the consent decision gates the tags and must resolve
          regardless of auth, query or app-shell state. */}
      <ConsentBootstrap />
      <ConsentedTags />
      <CookieConsentBanner />
      <Providers>
        <Suspense
          fallback={
            <div className="flex min-h-screen items-center justify-center">
              <Loader2 className="h-8 w-8 animate-spin text-cede-primary" />
            </div>
          }
        >
          <AppShell>{children}</AppShell>
        </Suspense>
        {!isRegionBlocked && <FeedbackWidget />}
      </Providers>
    </>
  );
}
